import APIService from '@/services/APIService.js';

export default {
  getAll() {
    return APIService.apiCall().get('/ferramentas-categorias/get-all');
  },
  getById(id) {
    return APIService.apiCall().get(`/ferramentas-categorias/get-by-id/${id}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/ferramentas-categorias/salvar/${postData.id}`, JSON.stringify(postData));
  }
};
